/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A content-scope namespace or exact tag and its distinct-memory count.
 */
export type BusinessMemoryContentScopeNode = {
  /**
   * Number of distinct memories assigned to this scope.
   */
  memoryCount: number;
  /**
   * Parent namespace. Omitted for namespace nodes.
   */
  parentScope?: string | undefined;
  /**
   * Namespace or exact content-scope tag.
   */
  scope: string;
};

/** @internal */
export const BusinessMemoryContentScopeNode$inboundSchema: z.ZodMiniType<
  BusinessMemoryContentScopeNode,
  unknown
> = z.pipe(
  z.object({
    memory_count: z.int(),
    parent_scope: z.optional(z.string()),
    scope: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "memory_count": "memoryCount",
      "parent_scope": "parentScope",
    });
  }),
);

export function businessMemoryContentScopeNodeFromJSON(
  jsonString: string,
): SafeParseResult<BusinessMemoryContentScopeNode, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BusinessMemoryContentScopeNode$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BusinessMemoryContentScopeNode' from JSON`,
  );
}
